module.exports = __webpack_public_path__ + "img/maps-and-flags.d4a12b30.svg";